// Selectors


import { RootState } from '../../store';

export const playgroundSelector = (state: RootState) => state.playgroundState

export const issueFlowSelector = (state: RootState) => state.playgroundState.issue

export const verifyFlowSelector = (state: RootState) => state.playgroundState.verify

export const issuedCredentialsSelector = (state: RootState) => state.playgroundState.issuedCredentials
